{
  "nav.myForms": "My Forms",
  "nav.myMarketplace": "My marketplace",
  "nav.logout": "Logout",

  "dashboard.subtitle": "Low-code form platform. Manage forms and data.",
  "dashboard.card.myForms.description": "View your forms or design a new one with drag-and-drop fields.",

  "forms.list.title": "My forms",
  "forms.list.description": "Create or edit form definitions.",
  "forms.list.new": "New form",
  "forms.list.empty": "No forms yet. Create one to get started.",
  "forms.list.error": "Failed to load forms.",
  "forms.list.deleteConfirm": "Delete the form \"{{name}}\" and all its data?",
  "forms.list.deleteError": "Failed to delete form.",

  "marketplace.title": "My marketplace",
  "marketplace.description": "Add marketplace forms to this customer account.",
  "marketplace.available": "Available forms",
  "marketplace.assigned": "Assigned forms",
  "marketplace.emptyAvailable": "No marketplace forms are available to add right now.",
  "marketplace.emptyAssigned": "No marketplace forms have been assigned yet.",
  "marketplace.add": "Add",
  "marketplace.adding": "Addingâ€¦",
  "marketplace.added": "\"{{name}}\" was added to this account.",
  "marketplace.assignedBadge": "Assigned",
  "marketplace.removing": "â€¦",
  "marketplace.loadError": "Failed to load marketplace forms.",
  "marketplace.customerMissing": "We couldn't determine the current customer account.",

  "forms.builder.back": "← Back to forms",
  "forms.builder.title.new": "New form",
  "forms.builder.title.edit": "Edit form",
  "forms.builder.name.label": "Form name",
  "forms.builder.name.placeholder": "My form",
  "forms.builder.loadError": "Failed to load form.",
  "forms.builder.fields.heading": "Fields",
  "forms.builder.fields.hint": "Drag a field type onto the form.",
  "forms.builder.canvas.heading": "Form layout",
  "forms.builder.canvas.placeholder": "Drop fields here",
  "forms.builder.properties.heading": "Properties",
  "forms.builder.listOptions.placeholder": "Option 1\nOption 2\nOption 3",
  "forms.builder.remove": "Remove field",
  "forms.builder.canvas.addCard": "Add card",
  "forms.builder.canvas.untitledCard": "Untitled card",

  "forms.run.back": "← Back to forms",
  "forms.run.fallbackTitle": "View form",
  "forms.run.notFound": "Form not found",
  "forms.run.loadError": "Failed to load",
  "forms.run.validation.mandatory": "\"{{label}}\" is mandatory. Please fill it in.",
  "forms.run.validation.maskInvalid": "\"{{label}}\" is invalid.",
  "forms.run.deleteConfirm": "Delete this item?",
  "forms.run.deleteFailed": "Delete failed",
  "forms.run.empty": "No items yet. Add one above.",
  "forms.run.saveFailed": "Save failed",
  "forms.run.actions": "Actions",
  "forms.run.addRecord": "Add record",

  "auth.notAuthenticated": "Not authenticated",

  "login.logAsAdmin": "Log as admin",

  "common.save": "Save",
  "common.saving": "Saving…",
  "common.update": "Save",
  "common.create": "Add record",
  "common.cancel": "Cancel",
  "common.loading": "Loading…",
  "common.edit": "Edit",
  "common.delete": "Delete",
  "common.close": "Close",
  "common.search": "search"
}

